module.exports = __webpack_public_path__ + "static/media/banner-img-wrp-img-2.083ab047.png";